import { ChatGptMediaType } from "@redotech/redo-prisma-client/enums";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";
import { imageIdFormat } from "../../ids";

export const ChatGptMediaContentTypeSchema = createEnum(ChatGptMediaType);

const ChatGptListingMediaSchema_ = z.object({
  url: z.string(),
  contentType: ChatGptMediaContentTypeSchema,
  imageId: imageIdFormat.schema.nullish(),
});
export const ChatGptListingMediaSchema: z.ZodType<ChatGptListingMedia> =
  ChatGptListingMediaSchema_;
export interface ChatGptListingMedia
  extends z.infer<typeof ChatGptListingMediaSchema_> {}
